import type React from 'react';

import type { ErrorHandlerProps } from '../pageContext';

export const StarterDashboardCommentsErrorHandler: React.FC<ErrorHandlerProps> = ({ context: { error } }) => {
	throw new Error(`Failed to retrieve data for StarterDashboardComments page (error: ${error})`);
};
